import { createElement as h } from "react"

import T from "prop-types"
import { cx, mapIndexed as map } from "ramda-extension/es"

import { useDynamicStyles, useLabelOverrides } from "./css"
import { Tooltip } from ".."

const defaultColorize = (_, index) => (index === 0 ? "#008859" : "#cf4444")

export const Level = ({
  className,
  color,
  leftLabel,
  rightLabel,
  colorize = defaultColorize,
  values = [{ value: 0.5 }],
  width,
  ...props
}) => {
  const { rail, root } = useDynamicStyles({ color, width })
  const { left, right, root: labelRoot } = useLabelOverrides({ color, width })

  return h(
    "div",
    {},
    h(
      "span",
      {},
      leftLabel || rightLabel
        ? h(
            "span",
            { className: cx(className, labelRoot) },
            h("span", { className: cx(className, left) }, leftLabel),
            h("span", {
              className: cx(className, right),
              ...props["data-qa"] && { "data-qa": props["data-qa"] },
            }, rightLabel),
          )
        : null,
    ),
    h(
      "span",
      { className: cx(className, root) },
      h("span", {
        className: cx(className, rail),
      }),
      ...map(
        ({ title, value }, index) =>
          h(
            "span",
            {
              className: cx(
                className,
                useDynamicStyles({ thumbColor: colorize(value, index) }).thumb,
              ),
              key: index,
              style: {
                color: colorize ? colorize(value, index) : undefined,
                left: `${value * 100}%`,
              },
            },
            title &&
              h(
                Tooltip,
                { title },
                h("div", {
                  style: {
                    height: "30px",
                    width: "16px",
                  },
                }),
              ),
          ),
        values,
      ),
    ),
  )
}

Level.propTypes = {
  className: T.string,
  color: T.string,
  colorize: T.func,
  disabled: T.bool,
  label: T.string,
  size: T.oneOf(["medium", "small"]),
  values: T.array,
}
